import feather from "feather-icons";

document.addEventListener("turbolinks:load", function() {
  feather.replace();
});
